<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <p style="font-size:18pt; line-height:150%; margin:0pt 0pt 10pt; text-align:center">
            <span style="font-family:宋体; font-size:18pt; font-weight:bold">委托扣款协议书</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify">
            <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify">
            <span style="font-family:宋体; font-size:10.5pt">客户：简称“您”或“本人”或“借款人”</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify">
            <span style="font-family:宋体; font-size:10.5pt">吉林亿联银行股份有限公司：简称“本行”或“亿联银行”</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify">
            <span style="font-family:宋体; font-size:10.5pt">绑定银行卡发卡银行：简称“发卡银行”</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify">
            <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您通过互联网（Internet）点击确认或以其他方式选择接受本协议，即表示您同意接受本协议的全部约定内容，并同意签署本委托扣款协议书，确认承担由此产生的一切后果和责任。双方经协商一致或您授权账户销户时本协议自动终止。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt">一、您保证提供给本行的银行卡资料（包括：卡号、姓名、证件号码、手机号码等）为您本人持有的真实、完整、准确、合法、有效的银行卡信息及个人信息，同意并授权本行将以上信息送至发卡银行进行核验。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">二、您同意并授权发卡银行或本行签约合作的支付清算机构接受本行委托，根据借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">身份证号：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">在本行的贷款本息及其他应付款项，从您提供的银行卡（卡号：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">【</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">；开户行：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">；</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:none">预留手机号：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【系统填充】；</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:none">以下简称为授权账户</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">）中进行扣款。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您承诺前述委托扣款视同您本人作出，不得向发卡银行及其他代理扣款的支付清算机构提出异议。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">三、您同意并授权本行根据借款人</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">在本行的贷款本息及其他应付款项，从您的授权账户中扣收。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您承诺前述委托扣款视同您本人作出，不得向本行提出异议。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">四、因您提供银行卡资料不准确或虚假，或您提供的授权账户余额不足或被挂失、冻结、销户等原因而引起的一切损失和法律责任，由您自行承担，与本行无关。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">五、因发卡银行或其他支付清算机构原因导致扣款错误或延迟，给您造成直接损失的，由相关责任方承担。</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本行不承担任何责任，但可协助您向其追究相应责任。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal">六、所有因本协议引起的或与本协议有关的任何争议将通过双方友好协商解决。如果双方不能通过友好协商解决争议</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">，则任何一方均可向亿联银行所在地有管辖权的人民法院提起诉讼。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">七、本委托协议书的委托期限自《借款合同》签订之日起至《借款合同》项下约定的各项欠款本息等款项全部偿付完毕之日止。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">客户确认：本人已认真阅读本协议，并特别注意字体加黑部分内容，贵行已应本人要求对相关条款予以明确说明。在完全理解本协议的情况下，同意本协议的全部内容，并同意签署此委托扣款协议书。</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">&#xa0;</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">客户（签字捺印）：</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">【系统填充客户电子签名】</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold"> 身份证号：</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:normal; text-decoration:underline">【系统填充】</span>
          </p>
          <p style="background-color:#ffffff; font-size:10.5pt; line-height:150%; margin:0pt; text-align:justify; text-indent:24pt">
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold"> </span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold"> </span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">【系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">年</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">【系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">月</span>
            <span style="font-family:宋体; font-size:10.5pt; text-decoration:underline">【系统填充】</span>
            <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">日</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* font-size: 12px; */
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
